import React, {useEffect} from 'react';
import {VOD_AFREECATV_DOMAIN} from 'constants/config';

/**
 * 404 페이지
 * 추후 UI 추가되면 리다이렉트 제외하고 UI본 넣기
 */

const NoMatchPage = () => {
  useEffect(() => {
    window.location.replace(VOD_AFREECATV_DOMAIN);
  }, []);
  return <div>{'"Redirect..."'}</div>;
};

export default NoMatchPage;
